import { useNavigate, useLocation } from 'react-router-dom';
import React from 'react';
import { Button, Grid, Typography, Paper, Box } from '@mui/material';
import { handleLogin } from '../utils/auth';
import NavigationBar from '../components/NavigationBar';

function LoginPage() {
  const location = useLocation();

  // Extract the redirect parameter or default to "/"
  const redirect = new URLSearchParams(location.search).get('returnUrl') || '/';
  console.log('Redirect parameter in LoginPage:', redirect);

  const handleLoginClick = () => {
    localStorage.setItem("returnUrl", redirect); // Store returnUrl
    handleLogin(redirect);
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Navigation Bar */}
      <NavigationBar userName="" userEmail="" tenantId="" onLogout={() => {}} />

      {/* Main Content */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexGrow: 1,
          padding: 3,
        }}
      >
        <Paper elevation={3} sx={{ padding: 4, width: '100%', maxWidth: 600, borderRadius: '25px' }}>
          <Typography variant="h5" align="center" gutterBottom>
            Login Required
          </Typography>
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleLoginClick}
                sx={{
                  borderRadius: '20px',
                  padding: '10px 20px',
                  fontWeight: 'bold',
                  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                }}
              >
                Login with Salesforce
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                fullWidth
                disabled
                sx={{
                  padding: 1,
                  backgroundColor: '#e0e0e0',
                  color: '#9e9e9e',
                  cursor: 'not-allowed',
                  borderRadius: '20px',
                }}
              >
                Login with Aquant
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Box>
  );
}

export default LoginPage;